document.addEventListener('DOMContentLoaded', function() {
    // 页面模块进入动效 (Intersection Observer)
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.15 // 当模块 15% 进入视口时触发
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target); // 触发一次后取消观察
            }
        });
    }, observerOptions);

    // 观察所有带有 fade-in-up 类的元素
    document.querySelectorAll('.fade-in-up').forEach(el => {
        observer.observe(el);
    });
});